__turbopack_context__.v({
  "chevronIcon": "SupplementLearnMoreModal-module__uvdNkG__chevronIcon",
  "closeButton": "SupplementLearnMoreModal-module__uvdNkG__closeButton",
  "collapsibleContent": "SupplementLearnMoreModal-module__uvdNkG__collapsibleContent",
  "collapsibleInner": "SupplementLearnMoreModal-module__uvdNkG__collapsibleInner",
  "descriptionSection": "SupplementLearnMoreModal-module__uvdNkG__descriptionSection",
  "descriptionText": "SupplementLearnMoreModal-module__uvdNkG__descriptionText",
  "detailItem": "SupplementLearnMoreModal-module__uvdNkG__detailItem",
  "detailsList": "SupplementLearnMoreModal-module__uvdNkG__detailsList",
  "divider": "SupplementLearnMoreModal-module__uvdNkG__divider",
  "footerButton": "SupplementLearnMoreModal-module__uvdNkG__footerButton",
  "groupTitle": "SupplementLearnMoreModal-module__uvdNkG__groupTitle",
  "groupedDetails": "SupplementLearnMoreModal-module__uvdNkG__groupedDetails",
  "headerInfo": "SupplementLearnMoreModal-module__uvdNkG__headerInfo",
  "headerPrice": "SupplementLearnMoreModal-module__uvdNkG__headerPrice",
  "headerSection": "SupplementLearnMoreModal-module__uvdNkG__headerSection",
  "modalContainer": "SupplementLearnMoreModal-module__uvdNkG__modalContainer",
  "modalContent": "SupplementLearnMoreModal-module__uvdNkG__modalContent",
  "productName": "SupplementLearnMoreModal-module__uvdNkG__productName",
  "sectionHeader": "SupplementLearnMoreModal-module__uvdNkG__sectionHeader",
  "sectionTitle": "SupplementLearnMoreModal-module__uvdNkG__sectionTitle",
  "shippingInfo": "SupplementLearnMoreModal-module__uvdNkG__shippingInfo",
  "stickyFooter": "SupplementLearnMoreModal-module__uvdNkG__stickyFooter",
  "thumbnailContainer": "SupplementLearnMoreModal-module__uvdNkG__thumbnailContainer",
});
